import React from 'react';

interface ServerErrorProps {
  onReset?: () => void;
}

const ServerError: React.FC<ServerErrorProps> = ({ onReset }) => {
  const handleRefresh = () => {
    if (onReset) {
      onReset();
    } else {
      window.location.reload();
    }
  };

  return (
    <main style={styles.container} role="main" aria-labelledby="server-error-heading">
      <div style={styles.content}>
        <p style={styles.errorCode}>500</p>
        <h1 id="server-error-heading" style={styles.headline}>Server Error</h1>
        <p style={styles.description}>
          Oops! Something went wrong on our end. Please try again later.
        </p>

        <button
          onClick={handleRefresh}
          style={styles.button}
          type="button"
          aria-label="Refresh the page"
        >
          Refresh Page
        </button>
      </div>
    </main>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column' as const,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    backgroundColor: '#FFFFFF',
    padding: '2rem',
  } as React.CSSProperties,
  content: {
    maxWidth: '480px',
    width: '100%',
    textAlign: 'center' as const,
  } as React.CSSProperties,
  errorCode: {
    fontFamily: "'General Sans', sans-serif",
    fontWeight: 700,
    fontSize: 'clamp(4rem, 10vw, 7rem)',
    letterSpacing: '-0.02em',
    color: '#374151',
    margin: '0 0 0.5rem 0',
    lineHeight: 1,
  } as React.CSSProperties,
  headline: {
    fontFamily: "'General Sans', sans-serif",
    fontWeight: 700,
    fontSize: 'clamp(1.5rem, 4vw, 2rem)',
    letterSpacing: '-0.02em',
    color: '#111827',
    margin: '0 0 1rem 0',
  } as React.CSSProperties,
  description: {
    fontFamily: "'Inter', sans-serif",
    fontWeight: 400,
    fontSize: '1rem',
    lineHeight: 1.6,
    color: '#111827',
    margin: '0 0 2.5rem 0',
  } as React.CSSProperties,
  button: {
    fontFamily: "'Inter', sans-serif",
    fontWeight: 400,
    fontSize: '1rem',
    lineHeight: 1.6,
    color: '#FFFFFF',
    backgroundColor: '#3B82F6',
    border: 'none',
    borderRadius: '8px',
    padding: '0.75rem 2rem',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease',
  } as React.CSSProperties,
};

export default ServerError;
